import React, { Component } from 'react';
import PropTypes from 'prop-types';
import InputMaskWrap from './input-mask-wrapper';
import bubbleUpEvents from '../../utilities/bubble-up-events';
import unpick from '../../../utilities/unpick';
import reformatValue from '../../utilities/reformat-value';

export default function SSNComponent(props) {
  const { onChange, isValid, hideValue, replacePattern, innerRef } = props;
  const p = unpick(props, ['ariaLabel', 'isValid', 'replacePattern', 'mask', 'maskChar', 'hideValue', 'innerRef']);
  let inputType = 'tel';

  const eventProps = replacePattern
    ? {
        onChange(e) {
          bubbleUpEvents(e, [reformatValue(e, replacePattern.regExpString, replacePattern.newSubStr), onChange]);
        },
      }
    : '';

  const InputField = (
    <input
      type={inputType}
      {...p}
      {...eventProps}
      inputMode="numeric"
      mask={props.mask || '999-99-9999'}
      maskChar={props.maskChar || ''}
      aria-label={props.ariaLabel || 'SSN'}
      aria-placeholder={props.placeholder || ''}
      aria-invalid={!isValid}
      ref={innerRef}
    />
  );

  return <InputMaskWrap hideValue={hideValue}>{InputField}</InputMaskWrap>;
}

Component.propTypes = {
  onChange: PropTypes.func,
};

Component.defaultProps = {
  onChange: undefined,
};
